import { BarChart } from '../../../renderers/bar-chart/bar-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { IOTS_VOLUME_BY_STATUS_BAR_CHART_DEFINITION } from './iots-volume-by-status-bar-chart.definition';
import { IOTS_VOLUME_BY_STATUS_BAR_CHART_MOCK_DATA } from './iots-volume-by-status-bar-chart.mock';

export const IotsVolumeByStatusBarChart = (props: ChartRendererProps) => (
    <BarChart
        {...props}
        stacked
    />
);

IotsVolumeByStatusBarChart.definition = IOTS_VOLUME_BY_STATUS_BAR_CHART_DEFINITION;
IotsVolumeByStatusBarChart.mockData = IOTS_VOLUME_BY_STATUS_BAR_CHART_MOCK_DATA;
